<template>
  <DrawerSlot>
    <div class="breadcrumbs">
      <v-list dense class="breadcrumbsText"> 管理 </v-list>
    </div>

    <v-list>
      <DrawerMenuItem
        :selected-menu="selectedMenu"
        name="代理店管理"
        path="/admin/agencies"
      />

      <DrawerMenuItem
        :selected-menu="selectedMenu"
        name="広告主管理"
        path="/admin/advertisers"
      />

      <!--
      <DrawerMenuItem
        :path="pointGroupsPath"
        :selected-menu="selectedMenu"
        name="地点管理"
      />
      -->

      <v-list-group v-model="openAccountManagementMenu">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>
                アカウント管理
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <DrawerMenuItem
          :selected-menu="selectedMenu"
          :path="accountPaths.accounts"
          name="アカウント一覧"
          children
        />
        <DrawerMenuItem
          v-if="showAccountInvitations"
          :selected-menu="selectedMenu"
          :path="accountPaths.invitations"
          name="アカウント招待情報"
          children
        />
      </v-list-group>

      <!--
      <v-list-group value="true">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>配信管理</v-list-tile-title>
          </v-list-tile>
        </template>

        <DrawerMenuItem
          :selected-menu="selectedMenu"
          name="配信リスト"
          path="/admin/inventory_list_targeting/system_owner"
        />

        <DrawerMenuItem
          :selected-menu="selectedMenu"
          name="配信リスト"
          path="/admin/inventory_list_targeting/agency"
        />

        <DrawerMenuItem
          :selected-menu="selectedMenu"
          name="IPアドレスリスト"
          path="/admin/ip_address_list_targeting/system_owner"
        />

        <DrawerMenuItem
          :selected-menu="selectedMenu"
          name="IPアドレスリスト"
          path="/admin/ip_address_list_targeting/agency"
        />
      </v-list-group>
      -->

      <DrawerMenuItem
        :selected-menu="selectedMenu"
        name="テーマ管理"
        path="/admin/theme"
      />

      <DrawerMenuItem
        :selected-menu="selectedMenu"
        name="メニュー管理"
        path="/admin/menu"
      />

      <!-- SOが飛べる代理店マージン管理ページ -->
      <DrawerMenuItem
        :selected-menu="selectedMenu"
        name="代理店マージン管理"
        path="/admin/agency_margin/system_owner"
      />
      <!-- 代理店が飛べる代理店マージン管理ページ -->
      <DrawerMenuItem
        :selected-menu="selectedMenu"
        name="代理店マージン管理"
        path="/admin/agency_margin/agency"
      />

      <v-list-group v-if="isSystemOwner" v-model="openRequestSubMenu">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>
                承認管理
                <v-chip color="green" text-color="white" class="count"
                  >{{ requestCount.total }}
                </v-chip>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>

        <!-- 予算承認画面 -->
        <DrawerMenuItem
          :selected-menu="selectedMenu"
          path="/admin/request/budget"
          children
        >
          予算<v-chip color="green" text-color="white" class="count children"
            >{{ requestCount.budgetRequest }}
          </v-chip>
        </DrawerMenuItem>

        <DrawerMenuItem
          :selected-menu="selectedMenu"
          path="/admin/request/map_reports"
          children
        >
          マップレポート
          <v-chip color="green" text-color="white" class="count children">
            {{ requestCount.mapReportRequest }}
          </v-chip>
        </DrawerMenuItem>

        <!-- メニュー承認画面 -->
        <DrawerMenuItem
          :selected-menu="selectedMenu"
          path="/admin/request/menu"
          children
        >
          メニュー<v-chip
            color="green"
            text-color="white"
            class="count children"
            >{{ requestCount.menuRequest }}
          </v-chip>
        </DrawerMenuItem>

        <!-- 代理店マージン承認画面 -->
        <DrawerMenuItem
          :selected-menu="selectedMenu"
          path="/admin/request/agency_margin"
          children
        >
          代理店マージン<v-chip
            color="green"
            text-color="white"
            class="count children"
            >{{ requestCount.agencyMarginRequest }}
          </v-chip>
        </DrawerMenuItem>
      </v-list-group>
      <DrawerMenuItem
        v-if="isSuperAdmin"
        :selected-menu="selectedMenu"
        @campaignRequestCount="campaignRequestCount = $event"
        name="キャンペーン管理"
        path="/admin/campaign"
      >
        <v-chip color="green" text-color="white" class="count">
          {{ campaignCount }}
        </v-chip>
      </DrawerMenuItem>
      <v-switch v-if="accessibleBeta" v-model="useBeta" :label="`ベータ版`" />
    </v-list>
  </DrawerSlot>
</template>

<script>
import DrawerSlot from '@/components/Shared/Drawer/DrawerSlot'
import DrawerMenuItem from '@/components/Shared/Drawer/DrawerMenuItem'
import { actions as currentAdvertiserActions } from '@/vuex/modules/currentAdvertiser/constants'
import {
  actions as requestActions,
  getters as requestGetters,
} from '@/vuex/modules/admin/request/constants'
import {
  actions as campaignActions,
  getters as campaignGetters,
} from '@/vuex/modules/admin/campaign/constants'
import AccountApi from '@/api/account'
import RouteHelper from '@/mixins/RouteHelper'

export default {
  name: 'AdminDrawer',
  components: { DrawerMenuItem, DrawerSlot },
  mixins: [RouteHelper],
  data() {
    return {
      selectedMenu: '',
      systemOwner: null,
      openRequestSubMenu: false,
      openAccountManagementMenu: false,
      accessibleBeta: false,
    }
  },
  computed: {
    isSystemOwner() {
      return this.$store.getters['account/isSystemOwner']
    },
    isSuperAdmin() {
      return this.$store.getters['account/isSuperAdmin']
    },
    ownerProfileId() {
      return this.systemOwner && this.systemOwner.ownerProfileId
    },
    userType() {
      return this.$store.getters['account/userType']
    },
    pointGroupsPath() {
      return `/admin/point_groups/${this.ownerProfileId}`
    },
    requestCount() {
      return this.$store.getters[requestGetters.requestCount]
    },
    canFetchRequestCount() {
      if (this.systemOwner === null) return false
      // eslint-disable-next-line no-prototype-builtins
      return this.systemOwner.hasOwnProperty('id') && this.isSystemOwner
    },
    campaignCount() {
      return this.$store.getters[campaignGetters.incompleteCampaignCount]
    },
    showAccountInvitations() {
      return ['super admin', 'system operator', 'administrator'].includes(
        this.userType,
      )
    },
    useBeta: {
      get() {
        const stringVal = () => {
          if (!this.$store.getters['account/isSuperAdmin']) return 'false'
          const storageKey = 'beta'
          const defaultVal = 'false'
          const storedVal = localStorage.getItem(storageKey)
          if (storedVal === null) {
            localStorage.setItem(storageKey, defaultVal)
            return defaultVal
          }
          return storedVal
        }
        return stringVal() === 'true'
      },
      set(value) {
        localStorage.setItem('beta', value)
      },
    },
    accountPaths() {
      return {
        accounts: '/admin/accounts',
        invitations: '/admin/accounts/invitations',
      }
    },
  },
  watch: {
    $route() {
      this.selectedMenu = this.$route.path
    },
    canFetchRequestCount(newVal) {
      // createdでfetchを動かすとsystemOwner系の取得、setと足並みが揃わないことがある
      if (newVal) this.fetchRequestCount()
    },
    isSuperAdmin(newVal) {
      if (newVal) {
        this.fetchMapReportRequestCount()
        this.fetchCampaignList()
      }
    },
    selectedMenu() {
      console.log(this.accountPaths)
      this.openAccountManagementMenu = Object.values(this.accountPaths).some(
        p => p === this.selectedMenu,
      )
    },
  },
  async created() {
    this.systemOwner = await AccountApi.getSystemOwner()

    const account = await AccountApi.getMe()
    this.accessibleBeta =
      account.item.belongType === 'system owner' && account.item.belongId === 1

    // 管理画面では現在の広告主を表示しない
    this.$store.dispatch(currentAdvertiserActions.RESET)

    // 以下のURLについて、ログイン中のアカウントによって出し分けする
    const payload = {
      uriPaths: [
        '/admin/agencies',
        '/admin/advertisers',
        '/admin/accounts',
        // '/admin/inventory_list_targeting/system_owner',
        // '/admin/inventory_list_targeting/agency',
        // '/admin/ip_address_list_targeting/system_owner',
        // '/admin/ip_address_list_targeting/agency',
        // '/admin/theme',
        // '/admin/menu',
        '/admin/request/budget',
        // '/admin/request/agency_margin',
        // '/admin/request/menu',
        '/admin/request/map_reports',
        '/admin/campaign',
        // '/admin/agency_margin/system_owner',
        // '/admin/agency_margin/agency',
        this.pointGroupsPath,
      ],
    }
    this.$store.dispatch('drawerUriAuths/INITIALIZE', payload)
    // 初回表示時、routingのパスを取得
    this.selectedMenu = this.$route.path

    if (this.isSuperAdmin) {
      this.fetchMapReportRequestCount()
      this.fetchCampaignList()
    }
  },
  mounted() {
    this.openSubMenuByCurrentPath()
  },
  beforeDestroy() {
    this.$store.dispatch(requestActions.RESET)
  },
  methods: {
    openSubMenuByCurrentPath() {
      if (this.underAdminRequestPage) {
        this.openRequestSubMenu = true
      }
    },
    openAccountMenuByCurrentPath() {
      if (this.underAdminAccountPage) {
        this.openAccountManagementMenu = true
      }
    },
    fetchRequestCount() {
      this.$store.dispatch(requestActions.FETCH_COUNT, {
        systemOwnerId: this.systemOwner.id,
      })
    },
    fetchMapReportRequestCount() {
      this.$store.dispatch(requestActions.FETCH_MAP_REPORT_COUNT)
    },
    fetchCampaignList() {
      this.$store.dispatch(campaignActions.FETCH_INCOMPLETE_CAMPAIGN_LIST)
    },
  },
}
</script>

<style scoped lang="scss">
.breadcrumbs {
  padding: 3px 16px;
}
.breadcrumbsText {
  color: #666;
}
.count {
  position: absolute;
  right: 0;
  font-size: 10px;
  height: 16px;

  ::v-deep .v-chip__content {
    padding: 0 4px;
    justify-content: center;
    min-width: 16px;
  }
}
.count.children {
  margin-right: 10px;
}
</style>
